if (!customElements.get('skin-school-tabs')) {
  class SkinSchoolTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (this.tabs.length === 0) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
        tab.addEventListener('keydown', (e) => this.handleKeydown(e));
      });

      const activeTab = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true') || this.tabs[0];
      this.selectTab(activeTab);
    }

    selectTab(tab) {
      this.tabs.forEach((t) => {
        const selected = t === tab;
        t.setAttribute('aria-selected', String(selected));
        t.setAttribute('tabindex', selected ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });
    }

    handleKeydown(event) {
      const index = this.tabs.indexOf(event.currentTarget);
      let next;

      switch (event.key) {
        case 'ArrowRight':
          next = this.tabs[(index + 1) % this.tabs.length];
          break;
        case 'ArrowLeft':
          next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
          break;
        case 'Home':
          next = this.tabs[0];
          break;
        case 'End':
          next = this.tabs[this.tabs.length - 1];
          break;
        default:
          return;
      }

      event.preventDefault();
      next.focus();
      this.selectTab(next);
    }
  }

  customElements.define('skin-school-tabs', SkinSchoolTabs);
}
